import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";

export const Search = (props) => {
    const [input, setInput] = useState(null);
    const [timer, setTimer] = useState(null);

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        if (timer) {
            clearTimeout(timer);
        }

        const newTimer = setTimeout(() => {
            props.onChange(newValue);
        }, 5000);

        setTimer(newTimer);
        setInput(newValue);
    };

    let handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            const newValue = e.target.value;
            if (timer) {
                clearTimeout(timer);
            }
            props.onChange(newValue);
        }
    }

    return (
        <>
            <TextField
                variant="standard"
                value={input != null ? input : props.value}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
                placeholder="Search"
                inputRef={(input) => input}
                InputProps={{
                    endAdornment: <SearchIcon fontSize="small" />,
                }}
            />
        </>
    );
};
